import { User } from '@prisma/client'
import { Form, Radio, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/executiveAssistant/common'
import { SelectProviderAccount } from '~/features/formConfiguration/client/components/CustomInputs/SelectProviderAccount'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepCalendarProviders: React.FC<Props> = ({ user, ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Connect your Calendar</TitlePrimary>

        <Typography.Text type="secondary" className="mb-10">
          Connect your Calendar to allow me to see your availabilities allowing
          me to automatically suggest schedules in the draft emails i will
          prepare for you
        </Typography.Text>

        <Form.Item name={['calendarServices', 'provider']}>
          <Radio.Group
            block={true}
            optionType="button"
            buttonStyle="solid"
            options={[
              {
                label: 'Google',
                value: 'google',
              },
              {
                label: 'Outlook',
                value: 'outlook',
              },
            ]}
          />
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {instance => {
            const provider = instance.getFieldValue([
              'calendarServices',
              'provider',
            ])

            if (provider === 'google') {
              return (
                <Form.Item
                  label="Add your Google Account"
                  name={['calendarServices', 'accountGoogleCalendar']}
                >
                  <SelectProviderAccount providerKey="googleCalendar" />
                </Form.Item>
              )
            }

            return (
              <Form.Item
                label="Add your Outlook Account"
                name={['calendarServices', 'accountOutlookCalendar']}
              >
                <SelectProviderAccount providerKey="outlookCalendar" />
              </Form.Item>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
